export const BOOST_TOOLTIP_ENABLED = 'boost.tooltip.enabled';
export const BOOST_INTRO_AUDIO = 'boost.intro.audio';
export const BOOST_INTRO_PLAYSESSIONFREQCAP_COUNT = 'boost.intro.playsessionfreqcap.count';
export const BOOST_OUTRO_AUDIO = 'boost.outro.audio';
export const BOOST_OUTRO_PLAYSESSIONFREQCAP_COUNT = 'boost.outro.playsessionfreqcap.count';
export const BOOST_TOOLTIP_DEVICEFREQCAP_COUNT = 'boost.tooltip.devicefreqcap.count';
